import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/homepage';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-primary-500">
                {siteInfo.logo}
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              {siteInfo.description}
            </p>
            <p className="text-xs text-foreground-400 mt-3">
              收藏本页，永不迷路 — 您最可靠的98堂入口导航
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <a href={`mailto:${siteInfo.email}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-mail-line mr-2" />
                {siteInfo.email}
              </a>
              <a href={`tel:${siteInfo.phone}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-phone-line mr-2" />
                {siteInfo.phone}
              </a>
              <span className="text-sm text-foreground-500">
                <i className="ri-map-pin-line mr-2" />
                {siteInfo.address}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-secondary-200/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 入口导航 - 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            本站仅提供平台入口导航，不存储任何用户数据
          </p>
        </div>
      </div>
    </footer>
  );
}